import { auth } from '../store/auth.js';

const routes = [];
let outletEl = null;
let layoutEl = null;
let onChange = null;

export function defineRoutes(list) {
  routes.length = 0;
  for (const r of list) routes.push(compile(r));
}

function compile(r) {
  const segs = r.path.split('/').filter(Boolean);
  const params = [];
  const regex = new RegExp('^/' + segs.map((s) => {
    if (s.startsWith(':')) { params.push(s.slice(1)); return '([^/]+)'; }
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }).join('/') + '$');
  return { ...r, regex, paramNames: params };
}

export function setOutlet(el) { outletEl = el; }
export function setLayoutSetter(fn) { layoutEl = fn; }
export function onRouteChange(fn) { onChange = fn; }

function matchRoute(path) {
  for (const r of routes) {
    const m = path.match(r.regex);
    if (m) {
      const params = {};
      r.paramNames.forEach((n, i) => params[n] = decodeURIComponent(m[i + 1]));
      return { route: r, params };
    }
  }
  return null;
}

function getPath() {
  const h = window.location.hash || '#/';
  const [pathOnly, query = ''] = h.slice(1).split('?');
  const path = pathOnly === '' ? '/' : pathOnly;
  const params = Object.fromEntries(new URLSearchParams(query));
  return { path, queryParams: params };
}

export async function navigate(path) {
  if (window.location.hash === '#' + path) {
    handleRoute();
  } else {
    window.location.hash = path;
  }
}

async function handleRoute() {
  const { path, queryParams } = getPath();

  // Auth guard
  if (!auth.isAuthed() && path !== '/login') {
    return navigate('/login');
  }
  if (auth.isAuthed() && path === '/login') {
    return navigate('/');
  }

  const matched = matchRoute(path);
  if (!matched) {
    outletEl.innerHTML = `<div class="empty"><h2>404</h2><p>Ruta no encontrada: ${path}</p></div>`;
    return;
  }

  // Layout: no chrome for /login
  if (layoutEl) layoutEl(path !== '/login');

  outletEl.innerHTML = '<div class="boot-loader"><span class="spinner"></span> Cargando...</div>';
  try {
    const ctx = { params: matched.params, query: queryParams };
    await matched.route.render(outletEl, ctx);
    // Page-fade en cada cambio de ruta (excluye login que ya tiene su animacion)
    if (path !== '/login') {
      outletEl.classList.remove('page-fade');
      // forza reflow para que el animation reinicie
      void outletEl.offsetWidth;
      outletEl.classList.add('page-fade');
    }
    if (onChange) onChange(path);
  } catch (err) {
    console.error(err);
    outletEl.innerHTML = `<div class="empty"><div class="empty-icon">⚠</div><h3>Algo salio mal</h3><p>${err.message}</p></div>`;
  }
}

export function startRouter() {
  window.addEventListener('hashchange', handleRoute);
  if (!window.location.hash) window.location.hash = '#/';
  handleRoute();
}
